import { ApiService } from "@core/api/api-service";
import { Survey } from "@domain/user/user-survey";

export class UserSurveyService {
	constructor(private readonly apiService: ApiService) {}

	async listSurveys(): Promise<Survey[]> {
		const result = await this.apiService.get<Survey[]>("/surveys");
		return result.data;
	}

	async completeSurvey(surveyId: string): Promise<void> {
		await this.apiService.post(`/surveys/${surveyId}/complete`);
	}

	async dismissSurvey(surveyId: string): Promise<void> {
		await this.apiService.post(`/surveys/${surveyId}/dismiss`);
	}
}
